import axios from 'axios'
import { Message, Loading } from 'element-ui'
import router from '@/router';

// 创建8083端口的axios实例，使用环境变量中的基础路径
const service = axios.create({
  baseURL: process.env.VUE_APP_API_ADMIN_BASE_URL, // 从环境变量获取8083端口基础路径
  timeout: 15000, // 超时时间设置为15秒
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// 加载实例（用于请求过程中的加载状态）
let loadingInstance = null

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 显示加载状态
    loadingInstance = Loading.service({
      lock: true,
      text: '加载中...',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    
    // 从localStorage获取token
    const token = localStorage.getItem('token')
    // 如果token存在，则添加到请求头
    if (token) {
      config.headers.Authorization = token
    }
    
    return config
  },
  (error) => {
    // 请求错误时关闭加载状态
    if (loadingInstance) loadingInstance.close()
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (loadingInstance) loadingInstance.close();
    return response;
  },
  (error) => {
    // 响应错误时关闭加载状态
    if (loadingInstance) loadingInstance.close()
    
    // 统一处理401未登录
    if (error.response?.data?.code === 401) {
      // 清除无效token
      router.push('/Login');
      Message.error('登录已过期，请重新登录')
      return Promise.reject(new Error('未登录，请重新登录'));
    }
    
    // 其他错误提示
    Message.error(error.response?.data?.message || '请求失败，请稍后重试')
    return Promise.reject(error);
  }
);

export default service
